













import { Component, Prop, Vue } from 'vue-property-decorator'
import AppDialog from '@core/components/AppDialog.vue'
import CSVImport from '@core/services/csv/CSVImport.vue'
import { CSVModelInterface } from '@core/services/csv/CSVModel.interface'
import { HierarchySetupDTO } from '../api'
import { get } from 'lodash/fp'

@Component({
  components: {
    AppDialog,
    CSVImport
  }
})
export default class HierarchyCSVUpload extends Vue {
  @Prop() csvModel: CSVModelInterface
  @Prop({ default: false }) isImporting: boolean

  importData: HierarchySetupDTO[] = null

  onHierarchySetupCsvUpload (records: HierarchySetupDTO[]) {
    this.$emit('processing-hierarchy-details', true)
    try {
      this.importData = records.map(record => {
        const keys = Object.entries(Object.getOwnPropertyDescriptors(Object.getPrototypeOf(record)))
          .filter(([, descriptor]) => typeof descriptor.get === 'function')
          .map(([key]) => key)
        const dto = {}
        keys.map(key => {
          dto[key] = get(key, record)
        })
        return dto as HierarchySetupDTO
      })
      this.$emit('processing-hierarchy-details', false)
    } catch (error) {
      console.error(error)
      this.$emit('processing-hierarchy-details', false)
    }
  }

  importCsv () {
    this.$emit('prepared-hierarchy-import-csv', this.importData)
  }
}
